import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { KeeniconComponent } from '../../partials';

@Component({
  selector: 'ui-form-label',
  imports: [NgClass, KeeniconComponent],
  templateUrl: './form-label.component.html',
  styleUrl: './form-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormLabelComponent {
  requiredLabel = false;
  class = input<string>('mb-2');
  tooltip = input<string>('');
  required = input<boolean | string>(false);

  constructor() {
    effect(() => {
      this.requiredLabel =
        this.required() !== null && `${this.required()}` !== 'false';
    });
  }
}
